import React, { ReactElement, useCallback, useRef, useState, VFC } from 'react';
import { JourneyMenu } from 'src/common/JourneyMenu';
import { EditorConfirmPanel } from 'src/editor/confirm-panel';
import { DeleteRegularIcon } from 'src/monet/icons';
import { Nullable } from 'src/types/nullable.type';
import { functionNoop } from 'src/utils/function/noop';

interface DashboardSettingsManageWorkspacesOptionsProps {
  onMenuOpen: () => void;
  onMenuClose: () => void;
  renderMenuOrigin: (onClick: () => void) => ReactElement;
  onDeleteWorkspaceConfirm: () => void;
}

export const DashboardSettingsManageWorkspacesOptions: VFC<DashboardSettingsManageWorkspacesOptionsProps> = ({
  onMenuOpen,
  onMenuClose,
  renderMenuOrigin,
  onDeleteWorkspaceConfirm,
}) => {
  const [activePanel, setActivePanel] = useState<Nullable<'remove-workspace'>>(null);

  const settingsMenuOpenRef = useRef(functionNoop);
  const settingsMenuCloseRef = useRef(functionNoop);

  const deleteWorkspaceOpenRef = useRef(functionNoop);
  const deleteWorkspaceCloseRef = useRef(functionNoop);

  const onMenuClicked = () => {
    settingsMenuOpenRef.current();
  };

  const onBack = () => {
    setActivePanel(null);
    deleteWorkspaceOpenRef.current();
    setTimeout(onMenuClicked, 50);
  };

  const onClosePanel = () => {
    setActivePanel(null);
    onMenuClose();
  };

  const onMenuItemClicked = useCallback(() => {
    setActivePanel('remove-workspace');
  }, []);

  if (activePanel === 'remove-workspace') {
    const onRevokeConfirmed = () => {
      onDeleteWorkspaceConfirm();
      onClosePanel();
    };

    return (
      <EditorConfirmPanel
        confirmCopy='Yes, delete'
        denyCopy='No, keep'
        copy='Deleting this Workspace will delete all the Journeys within it. This is irreversible.'
        openRef={deleteWorkspaceOpenRef}
        closeRef={deleteWorkspaceCloseRef}
        renderOrigin={() => renderMenuOrigin(onMenuClicked)}
        placement={'bottom-start'}
        onOpen={onMenuOpen}
        onClose={onClosePanel}
        onConfirm={onRevokeConfirmed}
        onDeny={onClosePanel}
        onBack={onBack}
      />
    );
  }

  return (
    <JourneyMenu
      onOpen={onMenuOpen}
      openRef={settingsMenuOpenRef}
      placement={'bottom-start'}
      closeRef={settingsMenuCloseRef}
      onClose={onMenuClose}
      renderOrigin={() => renderMenuOrigin(onMenuClicked)}
    >
      <JourneyMenu.Item className='text-bedrock-p text-bedrock-black text-left' onClick={onMenuItemClicked}>
        <div className='flex items-center space-x-sm'>
          <DeleteRegularIcon />
          <span className='text-bedrock-p text-bedrock-black'>Delete</span>
        </div>
      </JourneyMenu.Item>
    </JourneyMenu>
  );
};
